import React, { useState, useEffect } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { UpdateDirectDiscountApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import { toLocalDateTimeInput, toUnixSeconds } from "../../utils/dateTime";

const EditDirectDiscountModal = ({ Open, setOpen, discount, onSuccess }) => {
  const [amount, setAmount] = useState("");
  const [desc, setDesc] = useState("");
  const [dateStr, setDateStr] = useState(() => toLocalDateTimeInput());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!Open || !discount) return;
    setAmount(String(discount.amount ?? ""));
    setDesc(discount.desc != null ? String(discount.desc) : "");
    setDateStr(
      discount.date != null
        ? toLocalDateTimeInput(discount.date)
        : toLocalDateTimeInput()
    );
  }, [Open, discount?._id]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!discount?._id) {
      WarningToast("No discount selected");
      return;
    }
    const amt = Number(amount);
    if (!Number.isFinite(amt) || amt <= 0) {
      WarningToast("Enter a valid discount amount");
      return;
    }

    setLoading(true);
    try {
      const res = await UpdateDirectDiscountApi(discount._id, {
        amount: amt,
        desc: desc.trim(),
        date: toUnixSeconds(dateStr),
      });
      if (res.data.success) {
        SuccessToast("Discount updated");
        setOpen(false);
        if (typeof onSuccess === "function") onSuccess();
      } else {
        ErrorToast(res.data.error?.msg || "Failed");
      }
    } catch (err) {
      ErrorToast(
        err.response?.data?.error?.msg ||
          err.message ||
          "Failed to update discount"
      );
    }
    setLoading(false);
  };

  return (
    <CustomModal open={!!Open} setOpen={setOpen}>
      <div className="w-[min(92vw,440px)] pb-8 font-quicksand">
        <h1 className="w-full text-center font-[700] text-2xl py-6 px-4 text-ink">
          Edit discount
        </h1>
        <p className="text-center text-sm text-inkSecondary px-6 mb-4">
          {discount?.user_type === 1
            ? discount?.customerId?.name || "Customer"
            : discount?.companyId?.name || "Company"}
        </p>

        <div className="flex flex-col gap-y-3 px-8">
          <AuthInput
            label="Discount amount (PKR)"
            placeholder="Amount"
            Type="number"
            Value={amount}
            setValue={setAmount}
            Width="w-full"
          />
          <AuthInput
            label="Description"
            placeholder="Optional note"
            Value={desc}
            setValue={setDesc}
            Width="w-full"
          />
          <AuthInput
            label="Date & Time"
            placeholder="Select Date & Time"
            Type="datetime-local"
            Value={dateStr}
            setValue={setDateStr}
            Width="w-full"
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-6 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Save changes"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditDirectDiscountModal;
